import { LocalStorageService } from 'angular-2-local-storage';
var CrashService = /** @class */ (function () {
    function CrashService(storage) {
        this.storage = storage;
    }
    Object.defineProperty(CrashService.prototype, "hasCrashed", {
        get: function () {
            return this.storage.get('crashed') || false;
        },
        enumerable: true,
        configurable: true
    });
    CrashService.prototype.setCrashed = function () {
        this.storage.set('crashed', true);
    };
    CrashService.prototype.clear = function () {
        this.storage.remove('crashed');
    };
    return CrashService;
}());
export { CrashService };
